import React from 'react';

// FoutVanger — vangt elke render-crash op en toont een leesbaar scherm
// in plaats van een witte pagina. De echte foutmelding staat erbij,
// zodat een screenshot meteen vertelt wat er mis is.
export default class FoutVanger extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fout: null };
  }

  static getDerivedStateFromError(fout) {
    return { fout };
  }

  componentDidCatch(fout, info) {
    console.error('[FoutVanger]', fout, info && info.componentStack);
  }

  render() {
    if (!this.state.fout) return this.props.children;
    const f = this.state.fout;
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#0f172a', padding: 24, fontFamily: 'system-ui, sans-serif',
      }}>
        <div style={{ maxWidth: 560, width: '100%', textAlign: 'center', color: 'white' }}>
          <div style={{ fontSize: 52, marginBottom: 12 }}>{'\u26A0\uFE0F'}</div>
          <h2 style={{ margin: '0 0 8px', fontSize: 20 }}>Er ging iets mis in de app</h2>
          <p style={{ margin: '0 0 18px', fontSize: 14, color: '#94a3b8' }}>
            Herladen lost het meestal op. Blijft dit scherm terugkomen, stuur dan een screenshot
            van het blok hieronder naar Dennis.
          </p>
          <div style={{
            background: '#1e293b', border: '1px solid #334155', borderRadius: 10,
            padding: '12px 14px', textAlign: 'left', fontSize: 12.5, color: '#fca5a5',
            fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            maxHeight: 180, overflowY: 'auto', marginBottom: 18,
          }}>
            {String((f && (f.message || f)) || 'Onbekende fout')}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#00D4AA', color: '#0f172a', border: 'none', borderRadius: 10,
              padding: '12px 28px', fontSize: 15, fontWeight: 800, cursor: 'pointer',
            }}>
            {'\uD83D\uDD04'} App herladen
          </button>
        </div>
      </div>
    );
  }
}
